import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_DETAIL_UPDATE_MAIL_RESEND_REQUEST_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_UPDATE_MUTATION =
	graphql(/* GraphQL */ `
		mutation ReservationDetailUpdateMailResendRequestForManagementReservationItemDetailUpdate(
			$input: ReservationDetailUpdateMailResendRequestInput!
		) {
			reservationDetailUpdateMailResendRequest(input: $input) {
				reservationDetail {
					guestEmail
				}
				userErrors
			}
		}
	`);
